import styled from "styled-components";

const Strong = styled.strong`
  color: #9b6940;
  font-size: 70px;
  font-weight: 800;

  @media (max-width: 1199px) {
    font-size: 50px;
  }
  @media (max-width: 767px) {
    font-size: 24px;
    margin-left: 18px;

  }
`;
export default Strong;
